export const Models = [
  {
    image: '/img/projects/p1.jpg',
    text: {
      ru: 'Республика Молдова, Хынчештский район, село Фырлэдень',
      md: 'Republica Moldova, raionul Hîncești, satul Fîrlădeni',
      en: 'Fîrlădeni, Hîncești District, Republic of Moldova',
    },
    link: '/project1',
  },
  {
    image: '/img/projects/p2.jpg',
    text: {
      ru: 'Тирасполь, Молдова — теплоэлектростанция на базе двух контейнерных модулей JMC 420',
      md: 'Tiraspol, Moldova — centrală termoelectrică bazată pe două module containerizate JMC 420',
      en: 'Tiraspol, Moldova — combined heat and power plant based on two JMC 420 container modules',
    },
    link: '/project2',
  },
  {
    image: '/img/projects/p3.jpg',
    text: {
      ru: 'Бендеры, Молдова — строительство теплоэлектростанции на базе двух модулей JMS 420',
      md: 'Bender, Moldova — construcția unei centrale termoelectrice bazate pe două module JMS 420',
      en: 'Bender, Moldova — construction of a combined heat and power plant based on two JMS 420 modules',
    },
    link: '/project3',
  },
  {
    image: '/img/projects/p4.jpg',
    text: {
      ru: 'Губкинский, Ямало-Ненецкий автономный округ — электростанция собственных нужд на базе двух контейнерных модулей JGC 416',
      md: 'Gubkinsky, Yamalo-Nemets Autonom Okrug, Centrală auxiliară bazată pe două module de containere JGC 416',
      en: 'Gubkinsky, Yamalo-Nemets Autonomous Okrug, Auxiliary power plant based on two container modules JGC 416',
    },
    link: '/project4',
  },
];
